import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    currentList: [],
    pagination: PAGINATION,
    totalCount: 0,
    detailDialogVisible: false,
    coinList: []
  },
  mutations: {
    setCoinList(state, payload) {
      state.coinList = payload.slice();
    },
    setCurrentList(state, payload) {
      state.currentList = (payload.list && payload.list.slice()) || [];
      state.totalCount = payload.totalCount;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setPaginationSize(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getCoinList({ commit }) {
      api.getCoinList().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    list({ commit }, searchData) {
      let q = {};
      if(searchData.coinType && (searchData.coinType != '所有')) q.coinType = searchData.coinType;
      if(searchData.startTime) q.startTime = searchData.startTime.getTime();
      if(searchData.endTime) q.endTime = searchData.endTime.getTime();
      q.page = searchData.page || PAGINATION.page;
      q.size = searchData.size || PAGINATION.size;
      api.getCurrentList(q).then(({ data }) => {
        commit('setCurrentList', data);
        commit('setPaginationSize', {
          page: q.page,
          size: q.size
        });
      });
    },
    create({ commit }, current) { // eslint-disable-line
      return new Promise(resolve => {
        api.createCurrent(current).then(res => {
          resolve(res);
        });
      });
    },
    update({ commit }, current) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateCurrent(current).then(res => {
          resolve(res);
        });
      });
    },
    remove({ commit }, id) { // eslint-disable-line
      return new Promise(resolve => {
        api.removeContent(id).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('currentSetting', store);
